<template>
  <div class="period-filter">
    <div class="flex flex-wrap gap-2 items-end mb-2">
      <!-- Data Início -->
      <div class="w-full sm:w-auto">
        <label class="text-sm font-medium mb-1 block">Data Início</label>
        <b-form-input
          v-model="startDate"
          type="date"
          @change="handleDateChange"
          class="w-full"
          style="min-width: 150px;"
        >
        </b-form-input>
      </div>

      <!-- Data Fim -->
      <div class="w-full sm:w-auto">
        <label class="text-sm font-medium mb-1 block">Data Fim</label>
        <b-form-input
          v-model="endDate"
          type="date"
          @change="handleDateChange"
          class="w-full"
          style="min-width: 150px;"
        >
        </b-form-input>
      </div>
    </div>

    <!-- Filtros Rápidos -->
    <div class="flex flex-wrap items-end justify-between gap-2 mb-1">
      <div class="flex-grow">
        <label class="text-sm font-medium mb-1 block">Período Rápido</label>
        <div class="flex flex-wrap gap-2">
          <b-button
            v-for="period in quickPeriodOptions"
            :key="period.value"
            :variant="
              quickPeriod === period.value ? 'primary' : 'outline-secondary'
            "
            size="sm"
            @click="selectQuickPeriod(period.value)"
          >
            {{ period.text }}
          </b-button>
        </div>
      </div>

      <!-- Botão Limpar Filtros -->
      <div class="w-full flex items-end justify-end ml-auto mt-2 mb-2">
        <b-button variant="outline-danger" size="sm" @click="clearFilters">
          {{ $t('action.clear') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BFormInput, BButton } from 'bootstrap-vue'

export default {
  name: 'PeriodFilter',
  components: {
    BFormInput,
    BButton
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        start_date: null,
        end_date: null
      })
    }
  },
  data() {
    return {
      quickPeriod: 'last_6_months',
      startDate: '',
      endDate: '',
      quickPeriodOptions: [
        { value: 'last_3_months', text: 'Últimos 3 meses' },
        { value: 'last_6_months', text: 'Últimos 6 meses' },
        { value: 'last_12_months', text: 'Últimos 12 meses' },
        { value: 'this_month', text: 'Este mês' },
        { value: 'last_month', text: 'Mês anterior' },
        { value: 'this_year', text: 'Este ano' },
        { value: 'custom', text: 'Personalizado' }
      ]
    }
  },
  methods: {
    calculateQuickPeriod(period) {
      const today = new Date()
      let start = new Date()
      let end = new Date()

      switch (period) {
        case 'last_3_months':
          start.setMonth(today.getMonth() - 3)
          start.setDate(1)
          start.setHours(0, 0, 0, 0)
          end.setHours(23, 59, 59, 999)
          break
        case 'last_6_months':
          start.setMonth(today.getMonth() - 6)
          start.setDate(1)
          start.setHours(0, 0, 0, 0)
          end.setHours(23, 59, 59, 999)
          break
        case 'last_12_months':
          start.setMonth(today.getMonth() - 12)
          start.setDate(1)
          start.setHours(0, 0, 0, 0)
          end.setHours(23, 59, 59, 999)
          break
        case 'this_month':
          start = new Date(today.getFullYear(), today.getMonth(), 1)
          end = new Date(
            today.getFullYear(),
            today.getMonth() + 1,
            0,
            23,
            59,
            59,
            999
          )
          break
        case 'last_month':
          start = new Date(today.getFullYear(), today.getMonth() - 1, 1)
          start.setHours(0, 0, 0, 0)
          end = new Date(today.getFullYear(), today.getMonth(), 0)
          end.setHours(23, 59, 59, 999)
          break
        case 'this_year':
          start = new Date(today.getFullYear(), 0, 1)
          end = new Date(today.getFullYear(), 11, 31, 23, 59, 59, 999)
          break
        default:
          return { start: null, end: null }
      }

      return {
        start: start.toISOString().split('T')[0],
        end: end.toISOString().split('T')[0]
      }
    },
    selectQuickPeriod(period) {
      this.quickPeriod = period

      if (period === 'custom') {
        return
      }

      const dates = this.calculateQuickPeriod(period)
      this.startDate = dates.start
      this.endDate = dates.end
      this.emitFilters()
    },
    handleDateChange() {
      this.quickPeriod = 'custom'
      this.emitFilters()
    },
    emitFilters() {
      const filters = {
        start_date: this.startDate || null,
        end_date: this.endDate || null
      }
      this.$emit('input', filters)
      this.$emit('change', filters)
    },
    clearFilters() {
      this.quickPeriod = 'last_6_months'
      const dates = this.calculateQuickPeriod('last_6_months')
      this.startDate = dates.start
      this.endDate = dates.end
      this.emitFilters()
    }
  },
  beforeMount() {
    // Aplicar filtro padrão (últimos 6 meses)
    const dates = this.calculateQuickPeriod('last_6_months')
    this.startDate = dates.start
    this.endDate = dates.end
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.startDate = newVal.start_date || ''
          this.endDate = newVal.end_date || ''
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    // Emitir filtros iniciais após montar
    this.$nextTick(() => {
      this.emitFilters()
    })
  }
}
</script>

<style scoped>
.period-filter {
  width: 100%;
}
</style>

